<template>
	<div class="fextop" :class="{ selected: isHeaderSelected }">
		
		<div class="header">
			<div class="wrap">
				<a href="javascript:;" @click="toPath('MyIndex')" class="logo"><img src="../assets/images/logo.png" alt="" /></a>
				
				<!-- 👇 这里添加了点击事件 -->
				<div class='gh' @click="toggleHeaderSelected">
					<a href='javascript:;'></a>
				</div>

				<div class="rts">
					<a href="javascript:;" @click="toPath('service')"
						class="btn">{{ $t('nav.ServiceIntroduction') }}</a>
					<div class="sele" @click="toggleLanguageMenu">
						<h3>{{ currentLanguageText }}</h3>
						<div class="senli" v-show="showLanguageMenu">
							<ul>
								<li><a href="javascript:;" @click="changeLanguage('zh')">中文</a></li>
								<li><a href="javascript:;" @click="changeLanguage('en')">EN</a></li>
							</ul>
						</div>
					</div>
					<dl v-if="user_info==''">
						<dd class="on" @click="login()"><a href="javascript:;">
								<div class="ico">
									<img src="../assets/images/qw3-1.png" alt="" />
									<img src="../assets/images/qw3.png" alt="" />
								</div>
								<h4>{{ $t('nav.login') }}</h4>
							</a></dd>
						<dd @click="reg()"><a href="javascript:;">
								<div class="ico">
									<img src="../assets/images/qw4.png" alt="" />
									<img src="../assets/images/qw4-1.png" alt="" />
								</div>
								<h4>{{ $t('nav.Slgnup') }}</h4>
							</a></dd>
					</dl>
					<div class="dengls" v-else>
						<h6 @click="goToMyUser()">
							<div class="ico">
								<img :src="user_info.headimg||require('../assets/images/mrtx.png')" alt="" />
							</div>
							<p>{{user_info.username}}</p>
						</h6>
						<a href="javascript:;" class="bns" @click="loginout()"><img src="../assets/images/qw76.png"
								alt="" /></a>
					</div>
					<div class="notice" @click="toPath('notice')">
						<img src="../assets/images/qw5.png" alt="" />
						<div class="nume">
							{{user_info.unread_number||''}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="hnaver">
			<div class="wrap">
				<ul>
					<li 
					  v-for="(item, index) in nav_list" 
					  :key="item.id || index"
					  :class="{ on: changindex === index }" 
					  @click="handser(index, item)"
					>
					  <h3><a href="javascript:;">{{ getNavTitle(item) }}</a></h3>
					</li>
				</ul>
			</div>
		</div>
	</div>

	<div class="mask " v-if="is_tc">
		<div class="maskcent">
			<div class="wtanc">
				<div class="ico">
					<img src="../assets/images/qw30.png" alt="" />
				</div>
				<div class="close" @click="showTc(0)">
					<img src="../assets/images/gb.png" alt="" />
				</div>
				<h3>{{ $t('nav.Notification') }}</h3>
				<h6 v-html="Notification"></h6>
				<!--<a href="javascript:;" class="wbt" @click="showTc(0)">确定</a>-->
			</div>
		</div>
	</div>
</template>

<script>
	import {
		get,
		post
	} from '@/api/api.js'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'

	export default {
		name: 'Header',
		props: {
			msg: String
		},
		data() {
			return {
				is_tc: 0,
				Notification: '',
				nav_list: [],
				changindex: 0,
				user_info: '',
				showLanguageMenu: false,
				currentLanguage: 'zh',
				isHeaderSelected: false // 👈 控制 header 是否选中
			}
		},
		computed: {
			currentLanguageText() {
				return this.currentLanguage === 'zh' ? '中文' : 'EN'
			}
		},
		mounted() {
			this.getNot();
			this.getNav();
			this.getUser();
			this.initLanguage();
			document.addEventListener('click', this.handleClickOutside);
		},
		beforeDestroy() {
			document.removeEventListener('click', this.handleClickOutside);
		},
		methods: {
			// 👇 点击切换 header 的 selected 类
			toggleHeaderSelected() {
				this.isHeaderSelected = !this.isHeaderSelected;
			},
			// 获取导航显示标题
			getNavTitle(item) {
				const lang = localStorage.getItem('locale');
				if (lang === 'en') {
					return item.en_title || item.cn_title;
				}
				return item.cn_title || item.en_title;
			},
			initLanguage() {
				const locale = localStorage.getItem('locale');
				if (locale === 'en') {
					this.currentLanguage = 'en';
					this.$i18n.locale = 'en';
				} else {
					this.currentLanguage = 'zh';
					this.$i18n.locale = 'zh';
				}
			},
			toggleLanguageMenu(event) {
				event.stopPropagation();
				this.showLanguageMenu = !this.showLanguageMenu;
			},
			handleClickOutside() {
				this.showLanguageMenu = false;
			},
			changeLanguage(type) {
				console.log("切换语言:", type);
				this.currentLanguage = type;
				localStorage.setItem('locale', type);
				this.$i18n.locale = type;
				this.showLanguageMenu = false;
				this.getNav();
				this.getNot();
				window.dispatchEvent(new CustomEvent('languageChanged', {
					detail: {
						locale: type
					}
				}));
				location.reload();
			},
			async loginout() {
				try {
					await ElMessageBox.confirm(
						this.$t('nav.Doyouwanttologout'),
						this.$t('nav.prompt'), {
							confirmButtonText: this.$t('nav.confirm'),
							cancelButtonText: this.$t('nav.Cancel'),
							type: 'warning',
							center: true,
						}
					)

					const response = await post('logout', {}, 'json', {
						showLoading: true,
						loadingText: '退出中...',
						skipAuth: true
					})

					if (response.code == 200) {
						ElMessage.success('退出成功')
					} else {
						ElMessage.warning(response.msg || '退出失败，但已清除登录信息')
					}

					localStorage.removeItem('token')
					localStorage.removeItem('user_id')
					this.user_info = ''

					setTimeout(() => {
						this.$router.push({
							name: 'login'
						})
					}, 1500)

				} catch (error) {
					if (error === 'cancel') {
						console.log('用户取消了退出')
					} else {
						localStorage.removeItem('token')
						localStorage.removeItem('user_id')
						this.user_info = ''
						setTimeout(() => {
							this.$router.push({
								name: 'login'
							})
						}, 1500)
					}
				}
			},
			login() {
				this.$router.push({
					name: 'login',
					query: {}
				});
			},
			toPath(path, query = {}) {
				this.$router.push({
					name: path,
					query: query
				});
			},
			goToMyUser() {
				if (this.user_info && this.user_info.id) {
					this.$router.push({
						name: 'user',
						query: {
							id: this.user_info.id,
							type: '1'
						}
					});
				} else {
					this.$router.push({
						name: 'User'
					});
				}
			},
			reg() {
				this.$router.push({
					name: 'register',
					query: {}
				});
			},
			async getUser() {
				try {
					const response = await post('getUser2', {}, 'json')
					if (response.code === 200 && response.data) {
						this.user_info = response.data
					}
				} catch (error) {
					console.error('获取用户信息失败:', error)
				}
			},
			async getNot() {
				try {
					const response = await post('getNotification', {}, 'json')
					if (response.code === 200 && response.data) {
						this.Notification = response.data.content
						// 检查今天是否已经弹过
						const today = new Date().toISOString().slice(0, 10); // 'YYYY-MM-DD'
						const lastDate = localStorage.getItem('notification_date');
						if (lastDate !== today) {
							// 未弹过，显示弹窗并记录日期
							this.is_tc = 1;
							localStorage.setItem('notification_date', today);
						} else {
							this.is_tc = 0; // 不显示
						}
					}
				} catch (error) {
					console.error('获取通知失败:', error)
				}
			},
			async getNav() {
				try {
					const response = await post('navList', {}, 'json')
					if (response.code === 200 && response.data) {
						this.nav_list = response.data
					}
				} catch (error) {
					console.error('获取导航失败:', error)
				}
			},
			handser(index, item) {
			  console.log('点击导航：', item);
			  this.changindex = index; 
			
			  if (item.en_title === 'Home') {
			    this.$router.push({ name: 'Home' });
			    return;
			  }
			  let lang = localStorage.getItem('locale');
			  let nav_name = this.getNavTitle(item);
			  this.$router.push({
			    name: item.path,
			    query: {
			      id: item.id,
			      name: item.en_title,
			      nav_name: nav_name
			    }
			  });
			},
			showTc(type) {
				this.is_tc = type;
			},
		}
	}
</script>

<style scoped>
</style>